import {css} from '@isceco/widget-library2/external/lit'

export default css`
  :host {
    font-family: var(--isceco-font);
  }
  
  .item {
    margin: var(--isceco-space-300) 0;
    display: flex;
    align-items: center;
    gap: var(--isceco-space-200);
  }

  .item > svg {
    min-width: 30px;
    flex: 0;
  }

  .item > p {
    margin: 0;
    color: var(--isceco-color-grey-900);
    font-size: 0.8em;
  }
  
  .spacer {
    height: var(--isceco-space-100);
  }
`
